<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pmuxRn/tc-custom/9780830886494.jpg?1696025821527" alt="This image is the cover for the book The Morals of the Story"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Morals of the Story
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>&gt;<em>Christianity Today</em> 2019 Book of the Year Award of Merit, Apologetics/Evangelism</strong> </p> <p>What arguments best support the existence of God?</p> <p>For centuries the moral argument—that objective morality points to the existence of God—has been a powerful apologetic tool.</p> <p>In this volume, David and Marybeth Baggett offer a dramatic, robust, and even playful version of the moral argument. Tracing both its historical importance and its contemporary relevance, they argue that it not only still points to God's existence but that it also contributes to our ongoing spiritual transformation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Baggett, Marybeth Baggett
      </h2>
      
      <p class="authorDescription body article"><p>David Baggett (PhD, Wayne State University) is professor of philosophy in the Rawlings School of Divinity at Liberty University in Lynchburg, Virginia. He is the coauthor of <em>Good God: The Theistic Foundations of Morality</em>, <em>God and Cosmos: Moral Truth and Human Meaning</em>, and <em>At the Bend of the River Grand</em>. He is the editor of <em>Did the Resurrection Happen?</em> and the coeditor of <em>C.S. Lewis as Philosopher: Truth, Goodness, and Beauty</em>; <em>The Philosophy of Sherlock Holmes</em>; and <em>Harry Potter and Philosophy: If Aristotle Ran Hogwarts</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d7afcf9